import React, { useContext, useEffect, useState } from "react";
import { context } from "../FrontPanel/FrontPanel";
import Moment from "react-moment";
import Navbar from "../Shared/Navbar/Navbar";
import axios from "axios";
import Modal from "react-modal";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment/moment";
import { HiOutlineX } from "react-icons/hi";
import Footer from "../Shared/Footer/Footer";

export default function Profile() {
  const { userData, setUserData, update, setUpdate } = useContext(context);
  const [orders, setOrders] = useState([]);
  const params = useParams();
  useEffect(() => {
    console.count("render");
    axios
      .get(`orders-customer/${params.id}`)
      .then((res) => {
        if (res.status === 200) {
          setOrders(res.data.orders);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [params.id]);
  // show order details
  const [modalIsOpen, setIsOpen] = useState(false);
  const customStyles = {
    content: {
      top: "40%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "5px",
      maxHeight: "449px",
    },
  };
  const [orderShow, setOrderShow] = useState({});
  const orderDetails = (order) => {
    setIsOpen(true);
    setOrderShow(order);
  };
  console.log(orderShow);
  const navigate = useNavigate();
  const logOut = () => {
    setUserData({});
    setUpdate(!update);
    localStorage.removeItem("user");
    sessionStorage.removeItem("user");
    navigate("/");
  };
  return (
    <div>
      <Navbar />
      <div className="container mx-auto my-3 p-5">
        <div className="md:flex no-wrap md:-mx-2 ">
          {/* Left Side */}
          <div className="w-full md:w-3/12 md:mx-2 custom-card p-2">
            {/* Profile Card */}
            <div className="bg-white p-3">
              {/* <div className="image overflow-hidden">
                                <img className="h-auto w-full mx-auto" src="https://lavinephotography.com.au/wp-content/uploads/2017/01/PROFILE-Photography-112.jpg" alt="profile" />
                            </div> */}
              <h1 className="text-gray-900 font-bold text-xl leading-8 my-1">
                {userData?.user?.name}
              </h1>
              <h3 className="text-gray-600 font-lg text-semibold leading-6">
                Email: {userData?.user?.email}
              </h3>
              <h3 className="text-gray-600 font-lg text-semibold leading-6">
                Phone: {userData?.user?.phone_number}
              </h3>
              <ul className="bg-gray-100 text-gray-600 hover:text-gray-700 hover:shadow py-2 px-3 mt-3 divide-y rounded shadow-sm">
                <li className="flex items-center py-3">
                  <span>Total Orders</span>
                  {/* <span className="ml-auto"><span className="bg-green-500 py-1 px-2 rounded text-white text-sm">Active</span></span> */}
                  <span className="ml-auto">{orders?.length}</span>
                </li>
                <li className="flex items-center py-3">
                  <span>Member since</span>
                  <span className="ml-auto">
                    <Moment format="DD/MM/YYYY">
                      {userData?.user?.created_at}
                    </Moment>
                  </span>
                </li>
              </ul>
              <button
                className="text-[#fff] rounded-full mt-2 bg-[#134E47] text-base w-full py-2 "
                onClick={logOut}
              >
                Log out
              </button>
            </div>
            {/* End of profile card */}
            <div className="my-4" />
          </div>
          {/* Right Side */}
          <div className="w-full overflow-x-auto md:w-9/12 mx-2 min-h-64 custom-card p-2">
            <h5 className="text-center mb-2 font-bold">My Orders</h5>
            <table className="table-auto w-full border-collapse border border-slate-400">
              <thead>
                <tr>
                  <th className="border border-slate-300 p-2">SL</th>
                  <th className="border border-slate-300 p-2">Order No</th>
                  <th className="border border-slate-300 p-2">Date</th>
                  <th className="border border-slate-300 p-2">Total Price</th>
                  <th className="border border-slate-300 p-2">
                    Payment Method
                  </th>
                  <th className="border border-slate-300 p-2">Seller</th>
                  <th className="border border-slate-300 p-2">Status</th>
                  <th className="border border-slate-300 p-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {orders?.length > 0 &&
                  orders.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="border border-slate-300 p-2">
                          {index + 1}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {item?.order_no}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {moment(item?.created_at).format("DD/MM/YYYY")}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {parseFloat(item.total_price).toFixed(2)}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {item.payment_method}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {item.store?.store_name}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {item.status_id}
                        </td>
                        <td className="border border-slate-300 text-center">
                          <i
                            onClick={() => orderDetails(item)}
                            className="cursor-pointer fa-solid fa-eye "
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
        <Footer />
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        style={customStyles}
        contentLabel="our modal"
      >
        <div className="modal-header bg-white py-2 px-2">
          <h6 className="text-lg font-bold mb-1">
            
            <HiOutlineX
              onClick={() => setIsOpen(false)}
              className="inline float-right cursor-pointer"
            />
          </h6>
          <h6 className="text-lg font-bold text-center mb-1">Order Details</h6>
          <div className="d md:w-[800px]">
            <table className="table-auto w-full border-collapse border border-slate-400">
              <thead>
                <tr>
                  <th className="border border-slate-300">SL</th>
                  <th className="border border-slate-300">Order No</th>
                  <th className="border border-slate-300">Product Name</th>
                  <th className="border border-slate-300">Price</th>
                  <th className="border border-slate-300">Quantity</th>
                  <th className="border border-slate-300">Total Price</th>
                  <th className="border border-slate-300">Order Status</th>
                </tr>
              </thead>
              <tbody>
                {orderShow?.order_details?.length > 0 &&
                  orderShow?.order_details.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="border border-slate-300 p-2">
                          {index + 1}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {item?.order_no}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {item.product_name}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {item.price}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {item.qty}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {parseFloat(item.total_price).toFixed(2)}
                        </td>
                        <td className="border border-slate-300 p-2">
                          {item.status_id}
                        </td>
                      </tr>
                    );
                  })}
                <tr>
                  <td
                    colSpan={5}
                    className="text-right border border-slate-300 p-2 pr-2"
                  >
                    Grand Total
                  </td>
                  <td className="border border-slate-300 p-2">
                    {parseFloat(orderShow?.total_price).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
    </div>
  );
}
